<template>
    <div v-for="radiolist in radiolists" :aria-labelledby="radiolist.Id + '_label'" role="radiogroup" class="mx-2 mt-4" :class="radiolist.Invalid ? 'border-l-8 border-red-700 pl-8' : null">
        <div :id="radiolist.Id + '_label'" class="text-lg text-gray-700 font-semibold">{{ radiolist.Label }}</div>
        <ValidationMessages v-if="radiolist.ValidationMessages" :messages="radiolist.ValidationMessages"></ValidationMessages>
        <div :key="option.Value" v-for="option in radiolist.Options" class="mt-2 py-2 flex items-center">
            <input :id="GetOptionId(radiolist.Id, option.Value)" :name="radiolist.Label" :value="option.Value" type="radio" class="radio absolute top-0 left-0 w-8 h-8 opacity-0" />
            <label :for="GetOptionId(radiolist.Id, option.Value)" class="relative radio-label leading-none flex pl-8 text-xl items-center text-gray-800">{{ option.Label }}</label>
        </div>
    </div>
</template>

<script>
    import { default as ValidationMessages } from "../ValidationMessages.vue";

    export default {
        name: "Radiolist",
        components: {
            ValidationMessages,
        },
        data() {
            return {
                radiolists: [
                    {
                        Id: 'ExampleRadiolist1',
                        Invalid: false,
                        ValidationMessages: [''],
                        Label: 'I agree that I like ice cream',
                        Options: [
                            { Value: '1', Label: 'Chocolate' },
                            { Value: '2', Label: 'Strawberry' },
                            { Value: '3', Label: 'Vanilla' },
                            { Value: '4', Label: 'Other' }
                        ]
                    },
                    {
                        Id: 'ExampleRadiolist2',
                        Invalid: true,
                        ValidationMessages: ['You must agree that you like ice cream'],
                        Label: 'I agree that I like ice cream',
                        Options: [
                            { Value: '1', Label: 'Chocolate' },
                            { Value: '2', Label: 'Strawberry' },
                            { Value: '3', Label: 'Vanilla' },
                            { Value: '4', Label: 'Other' }
                        ]
                    }
                ],
            }
        },
        methods: {
            GetOptionId: function (name, value) {
                return `${name}-${value}`;
            }
        }
    };
</script>

<style>
    .radio-label::before {
        content: "";
        @apply absolute;
        @apply top-0;
        @apply left-0;
        @apply w-6;
        @apply h-6;
        @apply border-2;
        @apply border-gray-500;
        @apply rounded-full;
    }

    .radio + .radio-label::after {
        content: "";
        @apply absolute;
        @apply w-3;
        @apply h-3;
        @apply border-solid;
        @apply opacity-0;
        @apply border;
        @apply border-blue-700;
        @apply bg-blue-700;
        @apply rounded-full;
        top: 0.4rem;
        left: 0.4rem;
    }

    .radio:checked + .radio-label::after {
        @apply opacity-100;
    }

    .radio:focus + .radio-label::before {
        @apply outline-0;
        box-shadow: 0 0 0 3px rgb(66 153 225 / 50%);
    }
</style>